import type React from 'react'

export interface DataStatisticProps {
  label: string
  value: string
  prefix?: string
  suffix?: string
  tone?: 'default' | 'positive' | 'negative' | 'muted'
  className?: string
}

const toneClassName = (tone: DataStatisticProps['tone']) => {
  switch (tone) {
    case 'positive':
      return 'text-[#22C55E]'
    case 'negative':
      return 'text-[#f04438]'
    case 'muted':
      return 'text-[#9f9f9f]'
    default:
      return 'text-[#1f1f1f]'
  }
}

export const DataStatistic: React.FC<DataStatisticProps> = ({
  label,
  value,
  prefix,
  suffix,
  tone = 'default',
  className,
}) => {
  return (
    <div className={`flex flex-col gap-2 ${className ?? ''}`}>
      <p className="m-0 text-xs font-medium text-[#1f1f1f]">{label}</p>
      <p className={`m-0 text-[32px] font-medium ${toneClassName(tone)}`}>
        {suffix ? <span className="text-[#9f9f9f]">{suffix}</span> : null}
        {prefix ? <span className="text-[#9f9f9f]">{prefix}</span> : null}
        <span className={prefix ? 'ml-1' : ''}>{value}</span>
      </p>
    </div>
  )
}

export default DataStatistic
